<mat-expansion-panel id="description" class="bordered">
   <mat-expansion-panel-header>
      <mat-panel-title id="descriptionPanelTitle">
         Description and Instructions
      </mat-panel-title>
   </mat-expansion-panel-header>

   <shipment-cod *ngIf="codForm"></shipment-cod>

   <ng-container *ngIf="!isQuote.value">
      <ng-container *ngIf="descForm as description">
         <div class="overline">Shipment Description</div>
         <mat-form-field>
            <textarea id="descriptionTextarea" matInput [formControl]="description" [required]="config?.description?.required"></textarea>
            <mat-error id="descriptionError" libInputErrors [control]="description"></mat-error>
            <mat-hint id="descriptionHint" align="end" *ngIf="config?.description?.maxLength && description?.value?.length as l">{{l || 0}} / {{config.description.maxLength}}</mat-hint>
         </mat-form-field>
      </ng-container>
   </ng-container>

   <ng-container *ngIf="instForm as specialinstructions">
      <div class="overline">Special Instructions</div>
      <mat-form-field>
         <textarea id="instructionsTextarea" matInput [formControl]="specialinstructions" [required]="config?.specialinstructions?.required"></textarea>
         <mat-error id="instructionsError" libInputErrors [control]="specialinstructions"></mat-error>
         <mat-hint id="instructionsHint" align="end" *ngIf="config?.specialinstructions?.maxLength && specialinstructions?.value?.length as l">{{l || 0}} / {{config.specialinstructions.maxLength}}</mat-hint>
      </mat-form-field>
   </ng-container>
</mat-expansion-panel>
